import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/lib/data";
import { Asterisk } from "lucide-react";

export const LogoMarquee = () => {
  return (
    <div id="quality" className="bg-safety border-y-2 border-charcoal py-4 overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {MARQUEE_ITEMS.map((item, i) => {
          const isDeva = /[\u0900-\u097F]/.test(item);
          return (
            <div key={i} className="flex items-center gap-6 mx-6">
              <span className={`${isDeva ? "font-deva" : "font-display"} font-700 text-charcoal text-xl sm:text-2xl uppercase tracking-wide whitespace-nowrap`}>
                {item}
              </span>
              <Asterisk size={22} className="text-charcoal/70" />
            </div>
          );
        })}
      </Marquee>
    </div>
  );
};
